/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import React from 'react';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import Cookie from 'cookie-universal';
import localeData from './translations/language.json';

const cookies = Cookie();

addLocaleData([...en, ...fr, ...de]);

// var defLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
const languageCookie = cookies.get('language');
let defMessages;
if (!languageCookie) {
  // const defLanguageWithoutRegionCode = defLanguage.toLowerCase().split(/[_-]+/)[0];
  defMessages = localeData[languageCookie] || localeData.en;
} else { defMessages = localeData.en; }

export const LanguageContext = React.createContext({
  language: languageCookie,
  messages: defMessages,
  toggleLanguage: (lang) => {
    this.language = lang;
    this.messages = localeData[lang] || localeData[languageCookie] || localeData.en;
  },
});
